var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPriceDrop = function SvgPriceDrop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#PriceDrop_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.378 2v-.622c0-.378-.134-.702-.405-.973A1.327 1.327 0 0 0 6 0c-.378 0-.702.132-.973.395-.27.264-.405.585-.405.963v5.957L2.31 5.025a1.294 1.294 0 0 0-.953-.386c-.378 0-.696.129-.953.385-.27.257-.405.578-.405.963s.135.713.405.983l4.642 4.622c.135.149.284.253.446.314.162.061.331.091.507.091s.345-.03.507-.09c.162-.062.31-.166.446-.315l4.642-4.622c.27-.27.405-.598.405-.983s-.135-.706-.405-.963a1.33 1.33 0 0 0-.953-.395 1.292 1.292 0 0 0-.973.395l-2.29 2.291V2Z",
    fill: "#7A5D0E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "PriceDrop_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
};
export default SvgPriceDrop;